/* import __COLOCATED_TEMPLATE__ from './locale-option.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();